
import { useEffect, useRef } from 'react';

const BrandsSlider = () => {
  const sliderRef = useRef<HTMLDivElement>(null);

  const brands = [
    { name: 'Hikvision', logo: 'https://public.readdy.ai/ai/img_res/4394137466c917928294256a16028e69.jpg' },
    { name: 'Dahua', logo: 'https://readdy.ai/api/search-image?query=Dahua%20Technology%20logo%20brand%20security%20systems%2C%20professional%20corporate%20logo%20on%20white%20background%2C%20clean%20minimalist%20design%2C%20high%20resolution%20brand%20identity%2C%20grayscale%20version%2C%20simple%20and%20clear&width=200&height=200&seq=brand-dahua-002&orientation=squarish' },
    { name: 'Axis', logo: 'https://readdy.ai/api/search-image?query=Axis%20Communications%20logo%20brand%20network%20cameras%2C%20professional%20corporate%20logo%20on%20white%20background%2C%20clean%20minimalist%20design%2C%20high%20resolution%20brand%20identity%2C%20grayscale%20version%2C%20simple%20and%20clear&width=200&height=200&seq=brand-axis-003&orientation=squarish' },
    { name: 'Bosch', logo: 'https://readdy.ai/api/search-image?query=Bosch%20Security%20Systems%20logo%20brand%2C%20professional%20corporate%20logo%20on%20white%20background%2C%20clean%20minimalist%20design%2C%20high%20resolution%20brand%20identity%2C%20grayscale%20version%2C%20simple%20and%20clear&width=200&height=200&seq=brand-bosch-004&orientation=squarish' },
    { name: 'Honeywell', logo: 'https://readdy.ai/api/search-image?query=Honeywell%20Security%20logo%20brand%20access%20control%2C%20professional%20corporate%20logo%20on%20white%20background%2C%20clean%20minimalist%20design%2C%20high%20resolution%20brand%20identity%2C%20grayscale%20version%2C%20simple%20and%20clear&width=200&height=200&seq=brand-honeywell-005&orientation=squarish' },
    { name: 'Samsung', logo: 'https://readdy.ai/api/search-image?query=Samsung%20Security%20logo%20brand%20surveillance%20systems%2C%20professional%20corporate%20logo%20on%20white%20background%2C%20clean%20minimalist%20design%2C%20high%20resolution%20brand%20identity%2C%20grayscale%20version%2C%20simple%20and%20clear&width=200&height=200&seq=brand-samsung-006&orientation=squarish' },
    { name: 'Panasonic', logo: 'https://readdy.ai/api/search-image?query=Panasonic%20Security%20logo%20brand%20CCTV%20cameras%2C%20professional%20corporate%20logo%20on%20white%20background%2C%20clean%20minimalist%20design%2C%20high%20resolution%20brand%20identity%2C%20grayscale%20version%2C%20simple%20and%20clear&width=200&height=200&seq=brand-panasonic-007&orientation=squarish' },
    { name: 'Avigilon', logo: 'https://readdy.ai/api/search-image?query=Avigilon%20logo%20brand%20video%20analytics%20security%2C%20professional%20corporate%20logo%20on%20white%20background%2C%20clean%20minimalist%20design%2C%20high%20resolution%20brand%20identity%2C%20grayscale%20version%2C%20simple%20and%20clear&width=200&height=200&seq=brand-avigilon-008&orientation=squarish' },
  ];

  const duplicatedBrands = [...brands, ...brands];

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    let animationId: number;
    let position = 0;
    const speed = 0.5;

    const animate = () => {
      position -= speed;
      const sliderWidth = slider.scrollWidth / 2;
      if (Math.abs(position) >= sliderWidth) {
        position = 0;
      }
      slider.style.transform = `translateX(${position}px)`;
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);
    return () => { if (animationId) cancelAnimationFrame(animationId); };
  }, []);

  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-navy-light mb-4">
            شركاؤنا من <span className="text-primary">العلامات العالمية</span>
          </h2>
          <p className="text-gray-dark text-lg">
            نتعاون مع أفضل الشركات العالمية لتوفير أجود المنتجات والحلول الأمنية
          </p>
        </div>

        {/* Brands Slider */}
        <div className="relative">
          <div className="overflow-hidden">
            <div ref={sliderRef} className="flex items-center gap-8" style={{ width: 'fit-content' }}>
              {duplicatedBrands.map((brand, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 w-[180px] h-[180px] bg-white rounded-2xl border border-silver/40 p-8 flex items-center justify-center hover:border-primary hover:shadow-xl transition-all duration-300 group cursor-pointer"
                >
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    className="w-full h-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Gradient Overlays */}
          <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-white to-transparent pointer-events-none"></div>
          <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-white to-transparent pointer-events-none"></div>
        </div>
      </div>
    </section>
  );
};

export default BrandsSlider;
